<template>
    <div>
        <v-card max-width="1200" class="mx-auto mt-5">
            <v-card-title>
                <h4>CRD - Consulta de Distribuciones</h4>
            </v-card-title>
            <v-card-actions>
                <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
                <v-btn color="info" @click="cargarCabeceras">Actualizar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>

        <v-card v-if="cabeceraSeleccionada" max-width="1200" class="mx-auto mt-3">
            <v-card-title>
                <h5>Detalle - Distribución: {{ cabeceraSeleccionada.distributionId }}</h5>
                <v-spacer></v-spacer>
                <v-btn small color="red" @click="cabeceraSeleccionada = null; detalles = []">Cerrar</v-btn>
            </v-card-title>
            <v-data-table
                :loading="loadingDetalle"
                :headers="headersDetalle"
                dense
                :items="detalles"
                :items-per-page="20"
            >
                <template v-slot:item.participacion="{ item }">
                    {{ item.participacion ? item.participacion.toFixed(2) : '' }}
                </template>
                <template v-slot:item.monto="{ item }">
                    {{ item.monto ? item.monto.toFixed(2) : '' }}
                </template>
                <template v-slot:item.grossAmt="{ item }">
                    {{ item.grossAmt ? item.grossAmt.toFixed(2) : '' }}
                </template>
                <template v-slot:item.taxAmt="{ item }">
                    {{ item.taxAmt ? item.taxAmt.toFixed(2) : '' }}
                </template>
                <template v-slot:item.commAmt="{ item }">
                    {{ item.commAmt ? item.commAmt.toFixed(2) : '' }}
                </template>
            </v-data-table>
            <v-row v-if="detalles.length" class="pa-4" dense>
                <v-col><strong>Total filas:</strong> {{ detalles.length }}</v-col>
                <v-col><strong>Total Bruto:</strong> {{ totalGrossAmt.toFixed(2) }}</v-col>
                <v-col><strong>Total Impuestos:</strong> {{ totalTaxAmt.toFixed(2) }}</v-col>
                <v-col><strong>Total Comisión:</strong> {{ totalCommAmt.toFixed(2) }}</v-col>
                <v-col><strong>Monto total:</strong> {{ totalMonto.toFixed(2) }}</v-col>
            </v-row>
        </v-card>

        <v-card max-width="1200" class="mx-auto mt-3">
            <v-data-table
                :loading="loadingCabecera"
                :headers="headersCabecera"
                dense
                :items="cabeceras"
                :items-per-page="15"
                @click:row="seleccionarCabecera"
                class="clickable-row"
            >
            </v-data-table>
        </v-card>

    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loadingCabecera: false,
            loadingDetalle: false,
            cabeceras: [],
            cabeceraSeleccionada: null,
            detalles: [],
            headersCabecera: [
                { text: "ID", value: "id" },
                { text: "Sender ID", value: "senderId" },
                { text: "Distribución", value: "distributionId" },
                { text: "Fecha/Hora Creación", value: "creationDateTime" },
                { text: "Estado", value: "estado" },
            ],
            headersDetalle: [
                { text: "Tipo", value: "tipo" },
                { text: "Fecha", value: "fecha" },
                { text: "Hora", value: "hora" },
                { text: "Channel", value: "channel" },
                { text: "Obra", value: "obra" },
                { text: "IP", value: "ip" },
                { text: "Autor", value: "autor" },
                { text: "Partic.%", value: "participacion" },
                { text: "Monto Bruto", value: "grossAmt", align: "end" },
                { text: "Impuestos", value: "taxAmt", align: "end" },
                { text: "Comisión", value: "commAmt", align: "end" },
                { text: "Monto", value: "monto", align: "end" },
                { text: "Moneda", value: "moneda" },
            ],
        };
    },
    computed: {
        totalMonto() {
            return this.detalles.reduce((sum, f) => sum + parseFloat(f.monto || 0), 0);
        },
        totalGrossAmt() {
            return this.detalles.reduce((sum, f) => sum + parseFloat(f.grossAmt || 0), 0);
        },
        totalTaxAmt() {
            return this.detalles.reduce((sum, f) => sum + parseFloat(f.taxAmt || 0), 0);
        },
        totalCommAmt() {
            return this.detalles.reduce((sum, f) => sum + parseFloat(f.commAmt || 0), 0);
        },
    },
    mounted() {
        this.cargarCabeceras();
    },
    methods: {
        async cargarCabeceras() {
            this.loadingCabecera = true;
            try {
                const res = await axios.get("/crd/cabecera");
                this.cabeceras = res.data;
            } catch (error) {
                console.error("Error al cargar cabeceras:", error);
            } finally {
                this.loadingCabecera = false;
            }
        },
        async seleccionarCabecera(cabecera) {
            this.cabeceraSeleccionada = cabecera;
            this.loadingDetalle = true;
            this.detalles = [];
            try {
                const res = await axios.get("/crd/distribution", {
                    params: { distributionId: cabecera.distributionId },
                });
                this.detalles = res.data;
            } catch (error) {
                console.error("Error al cargar detalle:", error);
            } finally {
                this.loadingDetalle = false;
            }
        },
    },
};
</script>

<style scoped>
.clickable-row {
    cursor: pointer;
}
</style>
